export default class CurrencyUtil {
  public static formatWinePrice(price: number): string {
    if (price) {
      const formattedPrice = price.toFixed(2);
      return String(formattedPrice);
    }
    return "";
  }
}
